import { render, staticRenderFns } from "./productBanner.vue?vue&type=template&id=73c4743a&scoped=true&"
import script from "./productBanner.vue?vue&type=script&lang=js&"
export * from "./productBanner.vue?vue&type=script&lang=js&"
import style1 from "./productBanner.vue?vue&type=style&index=1&id=73c4743a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c4743a",
  null
  
)

export default component.exports